/*
 * @Date: 2023-10-07 15:19:29
 * @LastEditors: 'lidianbin' 'lidianbin@coocaa.com'
 * @LastEditTime: 2023-10-13 17:53:36
 * @FilePath: \c-web-cli\packages\plugin-engine-saas\lib\index.js
 */
import { createPluginOptions } from './utils/pluginOptions'
import PluginLoader from './loader/index'
export { default as PluginWrapper } from './wrapper/Index.vue'
export { IS_POWERED_BY_PLUGIN } from './utils/constant'
export { getGlobalData, setGlobalData } from './utils/common'
export { getAppOptions } from './wrapper/index.js'

/**
 *
 * @param { * } Vue
 * @param { { useLoader: boolean, fetch: function } } options
 */
export default function install (Vue, {
  useLoader = false,
  apiFetch,
  apiPrefix = '/violet-api',
  apiOptions,
  envMode = 'pro', // 区分插件环境
  fixPluginName // 插件名称修正方法
}) {
  createPluginOptions({
    useLoader,
    apiFetch,
    apiPrefix,
    apiOptions,
    envMode,
    fixPluginName
  })

  if (useLoader) {
    Vue.use(PluginLoader)
  }
}
